export default {
  setAbout: (state, payload) => {
    state.about = payload;
  },
  setPersonalPhotos: (state, payload) => {
    state.personalPhotos = [...state.personalPhotos, ...payload];
  },
  allPhotosLoaded: (state, payload) => {
    state.allPhotosLoaded = payload;
  },
  setMeta(state, payload) {
    state.meta = payload;
  },
  increasePage: (state) => {
    state.page++;
  },
  noResult: (state, payload) => {
    state.noResult = payload;
  },
  reset: (state) => {
    state.personalPhotos = [];
    state.allPhotosLoaded = false;
    state.meta = null;
    state.page = 1;
  }

};
